import { createContext, MutableRefObject } from 'react'

import { type Experiments } from './Experiments'

export const DEFAULT_EXPERIMENTS = {}

type AssignmentEvent = Record<string, string | undefined>
type EmittedAssignmentEvent = MutableRefObject<AssignmentEvent>

type ExperimentsContextProps = {
  experiments: Partial<Experiments>
  emittedAssignmentEvent?: EmittedAssignmentEvent
}
export const ExperimentsContext = createContext<ExperimentsContextProps>({
  experiments: DEFAULT_EXPERIMENTS,
})
